import { Typography } from 'src/components/common/Typography'
import {
  Noto_body1_b16,
  Noto_body1_r16,
  Noto_body2_b14,
  Noto_body2_m14,
  Noto_body2_r14,
  Noto_heading3_b20,
} from 'src/styles/fonts/NotoSansKrFonts'
import React from 'react'
import styled from 'styled-components'
import { Container } from 'src/components/common/Container'
import CouponCircleImage from 'src/components/common/CouponCircleImage'
import Skeleton from 'react-loading-skeleton'
import { getBrandAndCouponName } from 'src/utils'
import { ellip } from 'src/styles/mixin'
import { Roboto_num2_b16, Roboto_num3_r14 } from 'src/styles/fonts/RobotoFonts'
import { GiftReceiveResultPageProps } from 'src/pages/GiftCardPage/GiftReceiveResultPage'
import RenderIf from 'src/components/common/RenderIf'
import { Barcode } from 'src/components/common/Barcode'
import { Icon } from 'src/assets/svg/Icon'
import DownloadCouponLayout from 'src/pages/DownloadCouponPage/_components/DownloadCouponLayout'

const GiftResultMsgCard = ({
  giftDetailData,
  contentsStatus,
  handleImgDownLoad,
  componentRef,
}: GiftReceiveResultPageProps) => {
  const { CouponImage, CouponName, BrandName, Msg, BarCode } = giftDetailData
  const {
    title,
    description,
    couponTopBoxBlur,
    couponBottomBox,
    message: isShowMsg,
  } = contentsStatus

  return (
    <S.GiftResultMsgCardContainer $option="flex_row">
      <S.GiftMsgCardContentsContainer $option="flex_column">
        <S.GiftMsgCardTopContainer $option="flex_column">
          <Typography $fontStyle={Noto_heading3_b20} $color="var(--black-90)">
            {title}
          </Typography>
          <RenderIf when={!!description}>
            <Typography $fontStyle={Noto_body2_r14} $color="rgba(0, 0, 0, 0.70)">
              {description}
            </Typography>
          </RenderIf>
        </S.GiftMsgCardTopContainer>
        <S.GiftMsgCardMiddleContainer>
          <S.CouponInfoContainer $option="flex_column" $row_gap="12px" ref={componentRef}>
            <S.CouponInfoNameContainer $option="flex_column" $isBlur={couponTopBoxBlur}>
              <CouponCircleImage src={CouponImage} />
              <S.CouponInfoBrandName as={!!CouponName ? 'span' : Skeleton}>
                [{BrandName}]
              </S.CouponInfoBrandName>
              <S.CouponInfoCouponName as={!!CouponName ? 'span' : Skeleton}>
                {getBrandAndCouponName(CouponName).couponName}
              </S.CouponInfoCouponName>
            </S.CouponInfoNameContainer>
            <S.CouponInfoBarcodeContainer $option="flex_column">
              <RenderIf when={!couponTopBoxBlur}>
                <RenderIf when={!!BarCode}>
                  <Barcode.Image value={`${BarCode}`} barcode_height={96} />
                  <Barcode.Text value={`${BarCode}`} fontStyle={Roboto_num2_b16} />
                </RenderIf>
                <RenderIf when={!BarCode}>
                  <Skeleton height={100} />
                </RenderIf>
              </RenderIf>
            </S.CouponInfoBarcodeContainer>
          </S.CouponInfoContainer>
          <RenderIf when={couponBottomBox.type === 'download'}>
            <S.CouponBottomBoxContainer
              $option="flex_row_space_between"
              $bgColor="#314558"
              $textAlign="left"
            >
              <S.CouponDownloadTextContainer $option="flex_column" $row_gap="2px">
                <Typography $fontStyle={Noto_body1_b16} $color="var(--white)">
                  쿠폰 이미지 저장하고
                </Typography>
                <Typography $fontStyle={Noto_body1_r16} $color="var(--white)">
                  무료 쿠폰 확인하기
                </Typography>
              </S.CouponDownloadTextContainer>
              <S.CouponCircleBtn onClick={handleImgDownLoad} $bgColor="#00203D">
                <Icon.WhiteDownLoad />
              </S.CouponCircleBtn>
            </S.CouponBottomBoxContainer>
            {/*다운로드*/}
            <DownloadCouponLayout
              couponDetailData={giftDetailData!}
              componentRef={componentRef}
              barcode={giftDetailData?.BarCode!}
            />
          </RenderIf>
          <RenderIf when={couponBottomBox.type === 'used'}>
            <S.CouponBottomBoxContainer
              $option="flex_row_space_between"
              $bgColor="var(--black-20)"
              $textAlign="left"
            >
              <Typography $fontStyle={Noto_body1_b16} $color="var(--black-70)">
                선물 사용 완료
              </Typography>
              <S.CouponCircleBtn $bgColor="var(--black-40)">
                <Icon.BigCheck />
              </S.CouponCircleBtn>
            </S.CouponBottomBoxContainer>
          </RenderIf>
          <RenderIf when={couponBottomBox.type === 'cantUse'}>
            <S.CouponBottomBoxContainer $option="flex_column" $row_gap="2px">
              <Typography $fontStyle={Noto_body1_b16} $color="var(--black-70)">
                {couponBottomBox.text}
              </Typography>
              <Typography $fontStyle={Noto_body1_r16} $color="var(--black-50)">
                {couponBottomBox.subText}
              </Typography>
            </S.CouponBottomBoxContainer>
          </RenderIf>
        </S.GiftMsgCardMiddleContainer>
        <RenderIf when={isShowMsg}>
          <S.MsgDivider $option="flex_row" $column_gap="10px">
            <S.MsgDividerLine />
            Message
            <S.MsgDividerLine />
          </S.MsgDivider>
          <S.GiftMsgCardBottomContainer $option="flex_column" $row_gap="4px">
            <Typography $fontStyle={Noto_body2_b14} $color="#303030">
              메시지
            </Typography>
            <S.MsgBox $fontStyle={Noto_body2_r14} $color="#303030">
              “ {Msg} ”
            </S.MsgBox>
          </S.GiftMsgCardBottomContainer>
        </RenderIf>
      </S.GiftMsgCardContentsContainer>
    </S.GiftResultMsgCardContainer>
  )
}

export default GiftResultMsgCard

const S = {
  GiftResultMsgCardContainer: styled(Container)`
    justify-content: center;
    padding: 40px 20px;
    background-color: var(--brand-10);
  `,
  GiftMsgCardContentsContainer: styled(Container)`
    max-width: 320px;
    width: 100%;
  `,
  GiftMsgCardTopContainer: styled(Container)`
    align-items: center;
    margin-bottom: 30px;
    text-align: center;
    white-space: pre-line;
  `,
  GiftMsgCardMiddleContainer: styled(Container)``,
  CouponInfoContainer: styled(Container)`
    align-items: center;
    padding: 25px 20px;
    border-radius: 20px 20px 0 0;
    background-color: var(--white);
  `,
  CouponInfoNameContainer: styled(Container)<{ $isBlur: boolean }>`
    align-items: center;
    ${({ $isBlur }) => $isBlur && 'opacity: 0.3'};
  `,
  CouponInfoBrandName: styled(Typography)`
    margin: 14px 0 2px 0;
    ${Noto_body2_m14};
    color: var(--black-50);
  `,
  CouponInfoCouponName: styled(Typography)`
    ${Noto_body1_b16};
    color: var(--black-90);
    ${ellip('line2')};
    text-align: center;
  `,
  CouponInfoBarcodeContainer: styled(Container)`
    align-items: center;
  `,
  CouponBottomBoxContainer: styled(Container)<{ $bgColor?: string; $textAlign?: string }>`
    align-items: center;
    padding: 17px 20px;
    border-radius: 0 0 20px 20px;
    background-color: ${({ $bgColor }) => $bgColor || 'var(--black-20)'};
    text-align: ${({ $textAlign }) => $textAlign || 'center'};
  `,
  CouponDownloadTextContainer: styled(Container)`
    width: fit-content;
  `,
  CouponCircleBtn: styled.button<{ $bgColor: string }>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 46px;
    height: 46px;
    border-radius: 50%;
    background-color: ${({ $bgColor }) => $bgColor};
  `,
  MsgDivider: styled(Container)`
    ${Roboto_num3_r14};
    justify-content: center;
    align-items: center;
    margin: 20px 0;
    text-align: center;
    color: #4b4b4b;
  `,
  MsgDividerLine: styled(Container)`
    width: 101px;
    height: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.18);
  `,
  GiftMsgCardBottomContainer: styled(Container)`
    padding: 20px;
    border-radius: 26px 26px 26px 2px;
    background-color: var(--brand-20);
  `,
  MsgBox: styled(Typography)`
    white-space: pre-wrap;
  `,
}
